import { render, staticRenderFns } from "./tree-classify.vue?vue&type=template&id=62cb2c15"
import script from "./tree-classify.vue?vue&type=script&lang=js"
export * from "./tree-classify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports